import React from 'react';
import DateRangeSelector from '../DateRangeSelector';
import Select from 'react-select';
import { useSelectStyles } from '../../utils/selectStyles';

const StatisticsSelectionHeader = ({
  startDate,
  endDate,
  onDatesChange,
  clients,
  selectedClient,
  onClientChange,
  tools,
  selectedTool,
  onToolChange,
  includeInternal,
  setIncludeInternal
}) => {
  const selectStyles = useSelectStyles();

  return (
    <div className="py-4 mb-6 relative z-11">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
        <div className="md:col-span-1">
          <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">
            Période (semaine par défaut)
          </label>
          <DateRangeSelector
            startDate={startDate}
            endDate={endDate}
            onDatesChange={onDatesChange}
            maxDateRange={{ value: 12, unit: 'months' }}
            relative={false}
            includeFuture={false}
          />
        </div>

        <div className="md:col-span-1">
          <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">Client</label>
          <Select
            isClearable
            isSearchable
            value={selectedClient}
            onChange={onClientChange}
            options={clients}
            placeholder="Filtrer par client..."
            classNamePrefix="react-select"
            styles={selectStyles}
            menuPortalTarget={document.body}
          />
        </div>

        <div className="md:col-span-1">
          <label className="block text-xs font-medium text-gray-700 dark:text-gray-300 text-left mb-1.5">Outil</label>
          <Select
            isClearable
            isSearchable
            value={selectedTool}
            onChange={onToolChange}
            options={tools}
            placeholder="Filtrer par outil..."
            classNamePrefix="react-select"
            styles={selectStyles}
            menuPortalTarget={document.body}
          />
        </div>

        <div className="md:col-span-1 flex items-center justify-end h-10">
           <label className="inline-flex items-center cursor-pointer">
            <span className="mr-3 text-sm font-medium text-gray-700 dark:text-gray-300">
              Inclure interne
            </span>
            <div className="relative">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={includeInternal}
                onChange={(e) => setIncludeInternal(e.target.checked)}
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default StatisticsSelectionHeader;


